import React, { useState, useRef, useEffect } from 'react'
import { FiSearch } from 'react-icons/fi'
import {
  Container,
  SearchFields,
  Input,
  Select,
  Divider,
  SearchButton,
  AbsoluteModal,
  ExpandArea
} from './styled'
import { Logo } from '../../../common/components'
import styled from 'styled-components'

const RelativeSearch = styled.div`
  position: relative;

  svg {
    position: absolute;
    top: 50%;
    bottom: 50%;
    transform: translateY(-50%);
    right: 10px;
  }

  input {
    padding: 15px;
  }
`

const SearchBar = ({ onSearch }) => {
  const [open, setOpen] = useState(false)
  const [keyword, setKeyword] = useState('')
  const [experience, setExperience] = useState('')
  const [location, setLocation] = useState('')

  const ref = useRef()

  // Close expand area when clicking outside
  useEffect(() => {
    const handleClickOutside = event => {
      if (ref.current && !ref.current.contains(event.target)) {
        setOpen(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  const handleSearch = () => {
    setOpen(true)

    if (onSearch) {
      onSearch({ keyword, experience, location })
    }
  }

  return (
    <Container>
      <RelativeSearch>
        <Input
          className="search-input"
          placeholder="Search jobs here..."
          onFocus={() => setOpen(true)}
        />
        <FiSearch size={20} color="#535353" />
      </RelativeSearch>
      <AbsoluteModal open={open}>
        <div ref={ref}>
          <ExpandArea>
            <Logo
              style={{ width: 'auto', maxWidth: '150px', height: '60px' }}
            />
            <SearchFields>
              <Input
                placeholder="Enter keyword / designation / companies"
                value={keyword}
                onChange={e => setKeyword(e.target.value)}
              />

              <Divider />

              <Select
                style={{ width: '150px' }}
                value={experience}
                onChange={e => setExperience(e.target.value)}
              >
                <option value="">Select experience</option>
                <option value="1">1 year</option>
                <option value="2">2 years</option>
                <option value="3">3 years</option>
                <option value="4">4 years</option>
                <option value="5">5+ years</option>
              </Select>

              <Divider />

              <Input
                placeholder="Enter location"
                value={location}
                onChange={e => setLocation(e.target.value)}
              />

              <SearchButton onClick={handleSearch}>
                <FiSearch size={18} />
                Search
              </SearchButton>
            </SearchFields>
          </ExpandArea>
        </div>
      </AbsoluteModal>
    </Container>
  )
}

export default SearchBar
